import React, { useEffect, useState } from 'react';
import LinkButton, { LinkButtonProps } from '../LinkButton/LinkButton';

const MacIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 50 50'
      width='27'
      height='27'
    >
      <path
        fill='white'
        stroke='none'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeMiterlimit='10'
        strokeWidth='1'
        d='M44.529 34.75c-1.081 2.393-1.598 3.464-2.986 5.579-1.94 2.954-4.678 6.64-8.064 6.665-3.012.025-3.789-1.965-7.876-1.932-4.087.02-4.939 1.969-7.954 1.938-3.386-.031-5.978-3.352-7.92-6.3C4.3 32.429 3.727 22.736 7.082 17.579c2.374-3.657 6.13-5.805 9.657-5.805 3.592 0 5.85 1.974 8.82 1.974 2.882 0 4.637-1.979 8.791-1.979 3.142 0 6.464 1.712 8.838 4.666-7.766 4.255-6.504 15.347 1.341 18.315zM31.197 8.468c1.511-1.94 2.657-4.677 2.242-7.468-2.466.168-5.349 1.743-7.034 3.782-1.526 1.857-2.791 4.615-2.298 7.283 2.69.087 5.474-1.517 7.09-3.597z'
      />
    </svg>
  );
};

const LinuxIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xmlSpace='preserve'
      viewBox='0 2 48 48'
      width='27'
      height='27'
    >
      <path
        fill='#ECEFF1'
        d='m20.1 18.2.1 2.3-1.6 3-2.5 4.9-.5 4.1 1.8 5.8 4.1 2.3h6.2l5.8-4.4 2.6-6.9-6-7.3-1.7-4.1z'
      />
      <path
        fill='#263238'
        d='M34.3 23.9c-1.6-2.3-2.9-3.7-3.6-6.6-.7-2.9.2-2.1-.4-4.6-.3-1.3-.8-2.2-1.3-2.9-.6-.7-1.3-1.1-1.7-1.2-.9-.5-3-1.3-5.6.1-2.7 1.4-2.4 4.4-1.9 10.5 0 .4-.1.9-.3 1.3-.4.9-1.1 1.7-1.7 2.4-.7 1-1.4 2-1.9 3.1-1.2 2.3-2.3 5.2-2 6.3.5-.1 6.8 9.5 6.8 9.7.4-.1 2.1-.1 3.6-.1 2.1-.1 3.3-.2 5 .2 0-.3-.1-.6-.1-.9 0-.6.1-1.1.2-1.8.1-.5.2-1 .3-1.6-1 .9-2.8 1.9-4.5 2.2-1.5.3-4-.2-5.2-1.7.1 0 .3 0 .4-.1.3-.1.6-.2.7-.4.3-.5.1-1-.1-1.3-.2-.3-1.7-1.4-2.4-2-.7-.6-1.1-.9-1.5-1.3l-.8-.8c-.2-.2-.3-.4-.4-.5-.2-.5-.3-1.1-.2-1.9.1-1.1.5-2 1-3 .2-.4.7-1.2.7-1.2s-1.7 4.2-.8 5.5c0 0 .1-1.3.5-2.6.3-.9.8-2.2 1.4-2.9s2.1-3.3 2.2-4.9c0-.7.1-1.4.1-1.9-.4-.4 6.6-1.4 7-.3.1.4 1.5 4 2.3 5.9.4.9.9 1.7 1.2 2.7.3 1.1.5 2.6.5 4.1 0 .3 0 .8-.1 1.3.2 0 4.1-4.2-.5-7.7 0 0 2.8 1.3 2.9 3.9.1 2.1-.8 3.8-1 4.1.1 0 2.1.9 2.2.9.4 0 1.2-.3 1.2-.3.1-.3.4-1.1.4-1.4.7-2.3-1-6-2.6-8.3z'
      />
      <g fill='#ECEFF1'>
        <ellipse cx='21.6' cy='15.3' rx='1.3' ry='2' />
        <ellipse cx='26.1' cy='15.2' rx='1.7' ry='2.3' />
      </g>
      <g fill='#212121'>
        <ellipse
          cx='21.7'
          cy='15.5'
          rx='1.2'
          ry='.7'
          transform='rotate(-97.204 21.6767412 15.54238942)'
        />
        <ellipse cx='26' cy='15.6' rx='1' ry='1.3' />
      </g>
      <g fill='#FFC107'>
        <path d='M39.3 37.6c-.4-.2-1.1-.5-1.7-1.4-.3-.5-.2-1.9-.7-2.5-.3-.4-.7-.2-.8-.2-.9.2-3 1.6-4.4 0-.2-.2-.5-.5-1-.5s-.7.2-.9.6-.2.7-.2 1.7c0 .8 0 1.7-.1 2.4-.2 1.7-.5 2.7-.5 3.7 0 1.1.3 1.8.7 2.1.3.3.8.5 1.9.5 1.1 0 1.8-.4 2.5-1.1.5-.5.9-.7 2.3-1.7 1.1-.7 2.8-1.6 3.1-1.9.2-.2.5-.3.5-.9 0-.5-.4-.7-.7-.8zM19.2 37.9c-1-1.6-1.1-1.9-1.8-2.9-.6-1-1.9-2.9-2.7-2.9-.6 0-.9.3-1.3.7-.4.4-.8 1.3-1.5 1.8-.6.5-2.3.4-2.7 1-.4.6.4 1.5.4 3 0 .6-.5 1-.6 1.4-.1.5-.2.8 0 1.2.4.6.9.8 4.3 1.5 1.8.4 3.5 1.4 4.6 1.5 1.1.1 3 0 3-2.7.1-1.6-.8-2-1.7-3.6zM21.1 19.8c-.6-.4-1.1-.8-1.1-1.4 0-.6.4-.8 1-1.3.1-.1 1.2-1.1 2.3-1.1s2.4.7 2.9.9c.9.2 1.8.4 1.7 1.1-.1 1-.2 1.2-1.2 1.7-.7.2-2 1.3-2.9 1.3-.4 0-1 0-1.4-.1-.3-.1-.8-.6-1.3-1.1z' />
      </g>
      <g fill='#634703'>
        <path d='M20.9 19c.2.2.5.4.8.5.2.1.5.2.5.2h.9c.5 0 1.2-.2 1.9-.6.7-.3.8-.5 1.3-.7.5-.3 1-.6.8-.7-.2-.1-.4 0-1.1.4-.6.4-1.1.6-1.7.9-.3.1-.7.3-1 .3h-.9c-.3 0-.5-.1-.8-.2-.2-.1-.3-.2-.4-.2-.2-.1-.6-.5-.8-.6 0 0-.2 0-.1.1l.6.6zM23.9 16.8c.1.2.3.2.4.3.1.1.2.1.2.1.1-.1 0-.3-.1-.3 0-.2-.5-.2-.5-.1zM22.3 17c0 .1.2.2.2.1.1-.1.2-.2.3-.2.2-.1.1-.2-.2-.2-.2.1-.2.2-.3.3z' />
      </g>
      <path
        fill='#455A64'
        d='M32 34.7v.3c.2.4.7.5 1.1.5.6 0 1.2-.4 1.5-.8 0-.1.1-.2.2-.3.2-.3.3-.5.4-.6 0 0-.1-.1-.1-.2-.1-.2-.4-.4-.8-.5-.3-.1-.8-.2-1-.2-.9-.1-1.4.2-1.7.5 0 0 .1 0 .1.1.2.2.3.4.3.7.1.2 0 .3 0 .5z'
      />
    </svg>
  );
};

const WindowsIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 256 256'
      width='26'
      height='26'
    >
      <g
        fill='none'
        strokeMiterlimit='10'
        fontFamily='none'
        fontSize='none'
        fontWeight='none'
        style={{ mixBlendMode: 'normal' }}
        textAnchor='none'
      >
        <path fill='#fff' d='M16 208.4032V131.2h89.6v89.312z' />
        <path fill='#fff' d='M118.4 222.24V131.2h128v108.3392z' />
        <path fill='#fff' d='M16 118.4V41.1968l89.6-12.1088V118.4z' />
        <path fill='#fff' d='M118.4 118.4V27.36l128-17.2992V118.4z' />
      </g>
    </svg>
  );
};

type UserAgentOS = 'win' | 'mac' | 'linux';

const osIcons: Record<UserAgentOS, () => JSX.Element> = {
  win: WindowsIcon,
  mac: MacIcon,
  linux: LinuxIcon,
};

export type DownloadButtonProps = LinkButtonProps & {
  forceOs?: UserAgentOS;
};

export default function DownloadButton({
  className,
  forceOs,
  children,
  ...props
}: DownloadButtonProps): JSX.Element {
  const [os, setOS] = useState<UserAgentOS>('win');

  useEffect(() => {
    if (typeof window === 'undefined' || forceOs) {
      return;
    }

    try {
      const userAgent = window.navigator.userAgent.toLowerCase();

      if (userAgent.includes('win')) {
        return;
      }

      if (userAgent.includes('mac')) {
        setOS('mac');
      } else if (userAgent.includes('linux')) {
        setOS('linux');
      }
    } catch {
      // ignore
    }
  }, [forceOs]);

  const Icon = osIcons[forceOs ? forceOs : os];

  return (
    <LinkButton
      {...props}
      className={`download-button ${className ? className : ''}`}
    >
      <span className='download-button__icon'>
        <Icon />
      </span>
      <span className='download-button__label'>{children}</span>
    </LinkButton>
  );
}
